import { useState } from "react";
import InnerHTML from "dangerously-set-html-content";
import { t } from "@/i18n-js/instance";
import { LabelMd } from "@circle-react/components/shared/uikit/Typography/components/Label/LabelMd";
import { usePunditUserContext } from "@circle-react/contexts";
import { BodyMd } from "@circle-react-shared/uikit/Typography/components/Body/BodyMd";
import { ChatButton } from "../ChatButton";
import "./styles.css";

export interface ChatMessageProps {
  authorAvatarUrl?: string;
  authorName?: string;
  buttons: any[];
  content: string;
  createdAt: string;
  process?: (button: any) => void;
  showDisclaimer: boolean;
  type: "business" | "bot" | "user";
}

export const ChatMessage = ({
  type,
  authorAvatarUrl,
  authorName,
  content,
  buttons,
  process = () => {},
}: ChatMessageProps) => {
  const [selected, setSelected] = useState<any>(null);
  const { currentCommunityMember } = usePunditUserContext();
  const authorMapping = {
    business: {
      avatarUrl: authorAvatarUrl ?? "",
      name: authorName ?? "",
    },
    bot: {
      avatarUrl: "",
      name: t("support_widget.chatbot.name"),
    },
    user: {
      avatarUrl: currentCommunityMember?.avatar_url ?? "",
      name: currentCommunityMember?.name ?? "",
    },
  };

  const chatButtons = buttons.map(buttonProps => {
    const { label } = buttonProps;
    return (
      <ChatButton
        key={label}
        {...buttonProps}
        selected={selected}
        setSelected={setSelected}
        process={process}
      />
    );
  });

  return (
    <div className="ml-6 flex flex-row items-start gap-3 pt-6">
      <div className="flex flex-col">
        <div className="flex flex-row items-center gap-2">
          <LabelMd weight="semibold" color="text-dark">
            {authorMapping[type]["name"]}
          </LabelMd>
        </div>
        <div className="message-content pr-6">
          <BodyMd>
            <InnerHTML html={content} />
          </BodyMd>
          {chatButtons.length > 0 ? (
            <div className="mt-4 flex flex-row flex-wrap gap-2">
              {chatButtons}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
